import {useMemo} from "react";
import {css, cx} from "@panda/css";

import {PercentIcon} from "@pg-design/icons-module";
import {Tabs} from "@pg-design/tabs-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAmplitudePromotionViewportTracking} from "../../../promotion/hooks/use_amplitude_promotion_viewport_tracking";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {OFFER_LISTING_PROMOTION_TAB_LABELS} from "../constants/offer_listing_promotion_tabs";
import {getAmplitudeOfferListingPromotionTabSelectTrackingContext} from "../helpers/get_amplitude_offer_listing_promotion_tab_select_tracking_context";
import {useOfferListingPromotionTabs} from "../hooks/useOfferListingPromotionTabs";

interface IProps {
    className?: string;
    amplitudeItemListContext?: IAmplitudeItemListContext;
}

export const OfferListingPromotionTabs = (props: IProps) => {
    const {amplitudeItemListContext, className} = props;
    const {isMobile} = useUserDevice();
    const {activeTab, tabHrefs, promotionTabsHandler} = useOfferListingPromotionTabs(amplitudeItemListContext);
    const viewPromotionTrackingContext = useMemo(
        () => getAmplitudeOfferListingPromotionTabSelectTrackingContext(amplitudeItemListContext),
        [amplitudeItemListContext]
    );
    const {elementId} = useAmplitudePromotionViewportTracking({
        trackingContext: viewPromotionTrackingContext,
        elementId: "amplitude-promotion-tab-listing"
    });

    return (
        <div className={cx(isMobile && offerListTabsStyle, className)} data-id={elementId}>
            <Tabs
                fullWidth={!!isMobile}
                variant="pill"
                value={activeTab}
                onChange={promotionTabsHandler}
                tabs={[
                    {
                        title: OFFER_LISTING_PROMOTION_TAB_LABELS.all,
                        value: "all",
                        href: tabHrefs.all
                    },
                    {
                        title: (
                            <>
                                <PercentIcon className={css({mr: 1})} size="1.28" wrapperColor="var(--colors-highlight)" wrapperSize="2" wrapperType="circle" />
                                {OFFER_LISTING_PROMOTION_TAB_LABELS.promotions}
                            </>
                        ),
                        value: "promotions"
                    }
                ]}
            />
        </div>
    );
};

const offerListTabsStyle = css({
    width: "100%",
    minWidth: "0"
});
import {useMemo} from "react";
import {css, cx} from "@panda/css";

import {PercentIcon} from "@pg-design/icons-module";
import {Tabs} from "@pg-design/tabs-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAmplitudePromotionViewportTracking} from "../../../promotion/hooks/use_amplitude_promotion_viewport_tracking";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {OFFER_LISTING_PROMOTION_TAB_LABELS} from "../constants/offer_listing_promotion_tabs";
import {getAmplitudeOfferListingPromotionTabSelectTrackingContext} from "../helpers/get_amplitude_offer_listing_promotion_tab_select_tracking_context";
import {useOfferListingPromotionTabs} from "../hooks/useOfferListingPromotionTabs";

interface IProps {
    className?: string;
    amplitudeItemListContext?: IAmplitudeItemListContext;
}

export const OfferListingPromotionTabs = (props: IProps) => {
    const {amplitudeItemListContext, className} = props;
    const {isMobile} = useUserDevice();
    const {activeTab, tabHrefs, promotionTabsHandler} = useOfferListingPromotionTabs(amplitudeItemListContext);
    const viewPromotionTrackingContext = useMemo(
        () => getAmplitudeOfferListingPromotionTabSelectTrackingContext(amplitudeItemListContext),
        [amplitudeItemListContext]
    );
    const {elementId} = useAmplitudePromotionViewportTracking({
        trackingContext: viewPromotionTrackingContext,
        elementId: "amplitude-promotion-tab-listing"
    });

    return (
        <div className={cx(isMobile && offerListTabsStyle, className)} data-id={elementId}>
            <Tabs
                fullWidth={!!isMobile}
                variant="pill"
                value={activeTab}
                onChange={promotionTabsHandler}
                tabs={[
                    {
                        title: OFFER_LISTING_PROMOTION_TAB_LABELS.all,
                        value: "all",
                        href: tabHrefs.all
                    },
                    {
                        title: (
                            <>
                                <PercentIcon className={css({mr: 1})} size="1.28" wrapperColor="var(--colors-highlight)" wrapperSize="2" wrapperType="circle" />
                                {OFFER_LISTING_PROMOTION_TAB_LABELS.promotions}
                            </>
                        ),
                        value: "promotions"
                    }
                ]}
            />
        </div>
    );
};

const offerListTabsStyle = css({
    width: "100%",
    minWidth: "0"
});
